import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import ChemicalROBSTable from "./_elements/ChemicalROBSTable";
type OwnProps = {
	vesselId: string;
};
type VDMDashboardChemicalROBSProps = PropsFromRedux & OwnProps;
function VDMDashboardChemicalROBS(props: VDMDashboardChemicalROBSProps) {
	return (
		<>
			<ChemicalROBSTable />
		</>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardChemicalROBS);
